import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MenuItem } from '../interfaces/menu-item.interface';
import { trackById } from '../../../../utils/track-by';
import icPerson from '@iconify/icons-ic/twotone-person';
import icMoveToInbox from '@iconify/icons-ic/twotone-move-to-inbox';
import icListAlt from '@iconify/icons-ic/twotone-list-alt';
import icCheckCircle from '@iconify/icons-ic/twotone-check-circle';
import icAccessTime from '@iconify/icons-ic/twotone-access-time';
import icDoNotDisturb from '@iconify/icons-ic/twotone-do-not-disturb';
import icOfflineBolt from '@iconify/icons-ic/twotone-offline-bolt';
import icChevronRight from '@iconify/icons-ic/twotone-chevron-right';
import icArrowDropDown from '@iconify/icons-ic/twotone-arrow-drop-down';
import icBusiness from '@iconify/icons-ic/twotone-business';
import icVerifiedUser from '@iconify/icons-ic/twotone-verified-user';
import icLock from '@iconify/icons-ic/twotone-lock';
import icNotificationsOff from '@iconify/icons-ic/twotone-notifications-off';
import icOutlineSettings from '@iconify/icons-ic/outline-settings';
import { Icon } from '@abhinavakhil/iconify-angular';
import { PopoverRef } from '../../../../components/popover/popover-ref';
import { AuthService } from '../../../../../app/core/services/auth.service';
import { Observable } from 'rxjs';
import { UserModel } from '../../../../../app/core/models/user.model';
import { UserProfileModel } from '../../../../../app/core/models/user-profile.model';
import { UserProfileMode } from '../../../../../app/core/enums/user-profile.mode.enum';
import { Router } from '@angular/router';
import { ENUM_PERMISSIONS } from '../../../../../app/core/enums/permission.enum';
import { map } from 'rxjs/operators';
import { VersionInfo } from '../../../../../models/version-info.model';
import { VersionService } from '../../../../services/version.service';
import moment from 'moment';

export interface OnlineStatus {
  id: 'online' | 'away' | 'dnd' | 'offline';
  label: string;
  icon: Icon;
  colorClass: string;
}

@Component({
  selector: 'vex-toolbar-user-dropdown',
  templateUrl: './toolbar-user-dropdown.component.html',
  styleUrls: ['./toolbar-user-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolbarUserDropdownComponent implements OnInit {
  switchModeLoading = false;
  displaySettings = false;
  displaySettingsIcon = false;

  ENUM_PERMISSION = ENUM_PERMISSIONS;

  icListAlt = icListAlt;
  icMoveToInbox = icMoveToInbox;
  UserProfileMode = UserProfileMode;

  items: MenuItem[] = [
    // {
    //   id: '1',
    //   icon: icAccountCircle,
    //   label: 'Espace Admin',
    //   description: 'Personal Information',
    //   colorClass: 'text-teal',
    //   route: ''
    // },
    {
      id: '2',
      icon: icMoveToInbox,
      label: 'My Inbox',
      description: 'Messages & Latest News',
      colorClass: 'text-primary',
      route: '',
    },
    {
      id: '3',
      icon: icListAlt,
      label: 'Espace Admin',
      description: 'Réservé à la partie Core',
      colorClass: 'text-amber',
      route: '',
    },
    {
      id: '1',
      icon: icListAlt,
      label: 'Mon profile',
      description: 'Réservé à la partie Core',
      colorClass: 'text-amber',
      route: '',
    },
    // {
    //   id: '4',
    //   icon: icTableChart,
    //   label: 'Billing Information',
    //   description: 'Pricing & Current Plan',
    //   colorClass: 'text-purple',
    //   route: ''
    // }
  ];

  statuses: OnlineStatus[] = [
    {
      id: 'online',
      label: 'Online',
      icon: icCheckCircle,
      colorClass: 'text-green',
    },
    {
      id: 'away',
      label: 'Away',
      icon: icAccessTime,
      colorClass: 'text-orange',
    },
    {
      id: 'dnd',
      label: 'Do not disturb',
      icon: icDoNotDisturb,
      colorClass: 'text-red',
    },
    {
      id: 'offline',
      label: 'Offline',
      icon: icOfflineBolt,
      colorClass: 'text-gray',
    },
  ];

  activeStatus: OnlineStatus = this.statuses[0];

  trackById = trackById;
  icPerson = icPerson;
  icSettings = icOutlineSettings;
  icChevronRight = icChevronRight;
  icArrowDropDown = icArrowDropDown;
  icBusiness = icBusiness;
  icActive = icCheckCircle;
  icVerifiedUser = icVerifiedUser;
  icLock = icLock;
  icNotificationsOff = icNotificationsOff;
  icOutlineSettings = icOutlineSettings;

  user$ = new Observable<UserModel>();
  userProfile$ = new Observable<UserProfileModel>();
  accesCustomerGroupPermission = false;
  version$!: Observable<string>;

  // Nouvelles propriétés pour la version
  versionInfo: VersionInfo | null = null;
  formattedDeploymentDate = '';
  isUnknownDate = false;
  todayDate: Date = new Date(); // Date du jour

  constructor(
    private cd: ChangeDetectorRef,
    private router: Router,
    public popoverRef: PopoverRef<ToolbarUserDropdownComponent>,
    public authService: AuthService,
    private versionService: VersionService,
  ) {
    moment.locale('fr');
  }

  async ngOnInit() {
    this.user$ = this.authService.currentUserCoreValue();
    this.userProfile$ = this.authService.currentUserValue$();
    this.setDisplaySettings();

    this.versionService.versionInfo$.subscribe(info => {
      if (info) {
        this.versionInfo = info;

        // Vérifier si la date est "Unknown"
        this.isUnknownDate = info.deploymentInfo.createdAt === 'Unknown';

        // Formater la date si elle n'est pas "Unknown"
        if (!this.isUnknownDate) {
          const date = new Date(info.deploymentInfo.createdAt);

          this.formattedDeploymentDate = moment(date).format('DD MMM YYYY à HH:mm');

          console.log('Date de déploiement : ', this.formattedDeploymentDate);
        }
      }
    });
  }

  // -
  // getJSON(obj: any): Observable<any> {
  //     return JSON.stringify(obj, null, 2);
  // }
  // -
  // getJSON(obj: any): Observable<any> {
  //     return JSON.stringify(obj, null, 2);
  // }

  setDisplaySettings() {
    this.authService.currentUser.subscribe(user => {
      this.displaySettings = !!user?.isPredik;
      // PRED-3233 : la page « Administration tenant » (engrenage) s'ouvre aussi aux rôles détenant READ_CUSTOMER_GROUP.
      this.accesCustomerGroupPermission =
        !!user?.isPredik || this.authService.hasPermission(ENUM_PERMISSIONS.READ_CUSTOMER_GROUP);
      this.displaySettingsIcon = this.accesCustomerGroupPermission;
    });
  }

  setStatus(status: OnlineStatus) {
    this.activeStatus = status;
    this.cd.markForCheck();
  }

  async close(item: MenuItem) {
    if (item.id === '3') {
      this.switchModeLoading = true;
      this.authService.switchMode().subscribe(res => {
        console.log(res);
        window.location.reload();
      });
    } else {
      this.popoverRef.close();
    }
  }

  async switchMode() {
    this.switchModeLoading = true;
    this.authService.switchMode().subscribe((res: any) => {
      if (res.data.mode === 'CORE') {
        window.location.href = '/settings';
      } else {
        window.location.href = '/';
      }
    });
  }

  goCustumerGroupSettings() {
    this.router.navigate(['settings/customerGroup']).then(() => {
      this.popoverRef.close();
    });
  }
}
